<template>
<div class="orderPay">
  <div class="head">
    <p class="title">支付剩余时间</p>
    <div class="time" id="idn">
      <span>30</span>:<span>00</span>
    </div>
    <router-link class="info" :to="'/home?shopAlias='+cellitem.shopAlias">
      <img v-if="getdatanull(cellitem.logo)" :src="cellitem.logo">
			<img v-else src="../../images/logo.png">
      <p class="price">支付金额：<span>¥{{cellitem.payPrice}}</span></p>
      <p class="name text-hide">{{cellitem.shopName}}</p>
    </router-link>
  </div>
  <h1>选择支付方式</h1>
  <div class="pay">
    <ul>
      <li @click="changeactive('weixin')" class="wx" v-show="cellstate==1" :class="{active:cellactivename=='weixin'}">
        <div>
          <img src="../../images/icon/wx.png">
          微信支付
        </div>
      </li>
      <li @click="changeactive('alipay')" class="zfb" v-show="cellstate==2" :class="{active:cellactivename=='alipay'}" >
        <div>
          <img src="../../images/icon/zfb.png">
          支付宝
        </div>
      </li>
      <li class="cz" @click="changeactive('storePay')" v-if="cellitem.storeOpenStatus && cellitem.hadJoinMember" :class="{active:cellactivename=='storePay'}">
        <div>
          <img src="../../images/icon/cz.png">
          储值卡（余额¥{{cellitem.balance}}）
        </div>
      </li>
      <li v-if="canPayOnDelivery" @click="changeactive('payOnDelivery')" class="hd" :class="{active:cellactivename=='payOnDelivery'}">
        <div>
          <img src="../../images/icon/hd.png">
          货到付款
        </div>
      </li>
    </ul>
  </div>
  <div class="but" v-if="celldontpay==false" @click="gopay">
    确认支付 <span>¥{{cellitem.payPrice}}</span>
  </div>
  <div v-else class="but">
    无效订单
  </div>
</div>
</template>

<script>
	import api from '@/fetch/api'
	import Tictac from 'tictac.js'
	import keyboard from '../../../static/js/keyboard.js'
	export default {
		name: 'pay',
		data() {
			return {
				//外卖部分
				cellitem: '',
				cellactivename: '',
				cellstate: '',
        celldontpay: false,
        getmerData:'',

        canPayOnDelivery:false, //开启货到付款
        subPayType:'',//支付类型

			}
		},
		methods: {

			init() {
        let data = {
          loginShopAlias:this.$route.query.shopAlias,
          goodsOrderNo:this.$route.query.goodsOrderNo,
          subPayType:this.subPayType
        }
				api.ordertopay(this.geturl(data))
					.then(res => {
            this.$indicator.close();
            this.cellitem = res.resultObj;
            if(res.resultObj.storeOpenStatus && res.resultObj.hadJoinMember  && this.cellactivename == ''){
              this.cellactivename = 'storePay'
            }
						localStorage.removeItem(this.$route.query.shopAlias);
							//this.$nextTick(() => {
								var _this = this;
								var datas = '';
                var s=(Date.parse(Date())  - Date.parse(res.resultObj.orderTime))/1000  ;

								if(Number(s) < 30) {
									datas = Date.parse(res.resultObj.orderTime.replace(/-/g,'/'));
								} else {
									datas = Date.parse(Date());
								}

								Tictac.init({
									currentTime: datas, //设置当前时间
									interval: 5000, //执行callback的时间间隔
									callback: function() {
										//重复执行的回调
									}
								});
								Tictac.create('idn', {
									targetId: 'idn',
									expires: (Date.parse(res.resultObj.orderTime.replace(/-/g,'/')) / 1000 + 1800) * 1000,
									format: {
										minutes: '<span>{mm}</span>:',
										seconds: '<span>{ss}</span>'
									},
									timeout: function() {
										document.getElementById('idn').innerHTML = '<span>00</span>:<span>00</span>'
										_this.celldontpay = true;
									}
								})
							//})


					},res=>{

            // if(res.resultCode == 28008) {
            //   var dirct = encodeURIComponent(window.location.href);
            //   let data = {
            //     authType:'weixin',
            //     silent:true,
            //     redirectUrl:dirct
            //   }
						// 	api.authlogin(this.geturl(data))
						// 		.then(res => {
						// 			location.href = res.resultObj;
						// 		})
						// }
						// if(res.resultCode == 28009) {

            //   var dirct =encodeURIComponent(window.location.href);
            //   let data = {
            //     authType:this.stateon,
            //     silent:true,
            //     redirectUrl:dirct
            //   }
						// 	api.authlogin(this.geturl(data))

						// 		.then(res => {

						// 			location.href = res.resultObj;
						// 		}).then(res => {
						// 			this.$toast(res.resultMsg)
						// 		})
						// }
						this.$toast(res.resultMsg);
					})
			},
			changeactive(data) {
				this.cellactivename = data;
			},
			getPayWay1() {
				var ua = navigator.userAgent.toLowerCase();
				if(ua.match(/MicroMessenger/i) == "micromessenger") {
					//微信浏览器
					this.cellstate = 1;
					this.cellactivename = 'weixin';
          this.stateon = 'weixin';
          //判断是否是小程序访问
          var _this =this;
          function ready() {
            console.log(window.__wxjs_environment === 'miniprogram') // true
            if(window.__wxjs_environment === 'miniprogram'){
              _this.subPayType = 'wechatMini'
              _this.init();
              _this.xcxType = true
            }else{
              _this.subPayType = ''
              _this.init();
              _this.xcxType = false
            }
          }
          if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
            document.addEventListener('WeixinJSBridgeReady', ready, false)
          } else {
            ready()
          }
				} else if(ua.match(/alipay/i) == "alipay") {
					this.cellstate = 2;
					this.stateon = 'alipay';
          this.cellactivename = 'alipay';
          this.init();
				} else {
          this.cellstate = 3
          this.init();

        }
        let data = {
          shopAlias:this.$route.query.shopAlias
        }
        api.takeoutset(this.geturl(data)).then(res => {
          this.canPayOnDelivery = res.resultObj.canPayOnDelivery
          if(this.canPayOnDelivery && this.cellactivename == ''){
            this.cellactivename = 'payOnDelivery'
          }
        })
			},
			gopay() {
        var _this = this;
        if(_this.cellitem.payPrice == 0 && this.cellactivename != 'payOnDelivery'){
          _this.$toast("支付金额不能为0")
          return
        }
        if(this.cellstate == 3 && !this.canPayOnDelivery){
          this.$toast("无付款方式")
          return
        }
        if(this.cellactivename == 'storePay'){
          if(this.cellitem.balance < this.cellitem.payPrice){
              this.$toast("储值卡余额不足")
            return
          }
        }
        api.canPayJudge({
          "loginShopAlias": this.$route.query.shopAlias,
          "goodsOrderNo": this.$route.query.goodsOrderNo,
        }).then(res => {
          this.$indicator.open();
          if(this.cellactivename == 'storePay'){  //储值卡支付
            api.storagePay({
              "loginShopAlias": this.$route.query.shopAlias,
              "goodsOrderNo": this.$route.query.goodsOrderNo,
              "remark": '',
              "payFee": this.cellitem.payPrice,
              "payType": this.cellactivename,
              "casherAlias": this.getmerData ? this.getmerData : ''
              //"wechatUserType": 3
            })
            .then(res => {
              this.$indicator.close();
              _this.$router.replace({
                path: '/cell/orderdetail',
                query: {
                  "shopAlias": _this.$route.query.shopAlias,
                  "orderno": _this.$route.query.goodsOrderNo,
                }
              })
            }, res => {
              this.$indicator.close();
              this.$toast(res.resultMsg)
            })
          }else if(this.cellactivename == 'payOnDelivery'){  //货到付款
            api.takeoutdeliverypay({
              "loginShopAlias": this.$route.query.shopAlias,
              "goodsOrderNo": this.$route.query.goodsOrderNo,
              "remark": '',
              "payFee": this.cellitem.payPrice,
              "payType": this.cellactivename,
              "casherAlias": this.getmerData ? this.getmerData : ''
              //"wechatUserType": 3
            })
            .then(res => {
              this.$indicator.close();
              _this.$router.replace({
                path: '/cell/orderdetail',
                query: {
                  "shopAlias": _this.$route.query.shopAlias,
                  "orderno": _this.$route.query.goodsOrderNo,
                }
              })
            }, res => {
              this.$indicator.close();
              this.$toast(res.resultMsg)
            })
          }else{
            api.gopay({
              "loginShopAlias": this.$route.query.shopAlias,
              "goodsOrderNo": this.$route.query.goodsOrderNo,
              "remark": '',
              "payFee": this.cellitem.payPrice,
              "payType": this.cellactivename,
              "subPayType":this.subPayType,
              "casherAlias": this.getmerData ? this.getmerData : ''
              //"wechatUserType": 3
            })
            .then(res => {
              this.$indicator.close();
              var retCode = res.resultObj.retCode;

              //alert(res.resultObj.tradeNO.split('frag')[0])
              if(this.cellactivename == 'weixin') {
                //this.wxdata.appId = this.item.wechat_app_id;
                this.wxdata.appId = res.resultObj.wxAppId;
                this.wxdata.timeStamp = res.resultObj.wxTimeStamp;
                this.wxdata.nonceStr = res.resultObj.wxNonceStr;
                this.wxdata.package = res.resultObj.wxPackage;
                this.wxdata.signType = res.resultObj.wxSignType;
                this.wxdata.paySign = res.resultObj.wxPaySign;
                //商户订单号
                this.mchNo = res.resultObj.mchNo;

                if(typeof WeixinJSBridge == "undefined") {
                  if(document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                  } else if(document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                  }
                } else {
                  this.onBridgeReady();
                }

              }
              if(this.cellactivename == 'alipay') {
                var tradeNo = res.resultObj.outOrderNo;
                if(tradeNo.indexOf('frag') >= 0) {
                  tradeNo = tradeNo.split('frag')[0];
                }

                if(retCode == "86") {
                  this.$toast("亲！在街上店铺使用支付宝钱包付款时，必须使用支付宝账号登录才可以实现支付。");
                  //updateIncomeDetailRemark(incomeDetailId,"亲！在街上店铺使用微信付款时，必须使用微信账号登录才可以实现支付,code=86");
                  return;
                } else if(retCode == "87" || retCode == "95") {
                  this.$toast("下单失败。");
                  return;
                } else if(retCode == "88") {
                  this.$toast("订单金额已超过每日限额，无法完成支付。");
                  //updateIncomeDetailRemark(incomeDetailId,"订单金额已超过每日限额，无法完成支付,code=88");
                  return;
                } else if(retCode == "89") {
                  this.$toast("二维码不存在。");
                  //updateIncomeDetailRemark(incomeDetailId,"二维码不存在。code=89");
                  return;
                } else if(retCode == 1) {

                  AlipayJSBridge.call("tradePay", {   //唤醒支付宝支付
                    tradeNO: tradeNo

                  }, function(result) {

                    var resultCode = result.resultCode;
                    //6001 取消操作，9000 支付成功
                    if(resultCode == "9000") {
                      //修改为已支付但未到账
                      setTimeout(function(){
                      _this.$router.replace({
                        path: '/cell/orderdetail',
                        query: {
                          "shopAlias": _this.$route.query.shopAlias,
                          "orderno": _this.$route.query.goodsOrderNo,
                          "success":1
                        }
                      })
                      },1500)
                      //window.location.href=baseUrl+'/msbankali/hadPay?mchNo='+mchNo;
                    } else if(resultCode == "6001") {
                      //取消、支付失败操作
  //										_this.$router.push({
  //											path: '/cell/payfail',
  //											query: {
  //												shopAlias: _this.$route.query.shopAlias,
  //												"orderno": _this.$route.query.goodsOrderNo
  //											}
  //										})

                      //window.location.href=baseUrl+'/msbankali/hadPayFail?alias='+alias;
                      updateIncomeDetailRemark(incomeDetailId,"6001:用户中途取消。");
                    } else {
                      _this.$router.replace({
                        path: '/cell/payfail',
                        query: {
                          shopAlias: _this.$route.query.shopAlias,
                          "orderno": _this.$route.query.goodsOrderNo
                        }
                      })
                      updateIncomeDetailRemark(incomeDetailId,"支付宝支付失败："+resultCode);
                      //支付失败

                    }
                  });
                }
              }

            }, res => {

              this.$indicator.close();
              if(res.resultMsg == '当前用户未绑定支付宝账户'){

                var dirct =encodeURIComponent(window.location.href);
                let data = {
                  authType:this.stateon,
                  silent:true,
                  redirectUrl:dirct
                }
                api.authlogin(this.geturl(data))
                  .then(res => {
                    location.href = res.resultObj;
                  }).then(res => {
                    this.$toast(res.resultMsg)
                  })
              }
              else{
                this.$toast(res.resultMsg);
              }

            })
          }
        }, res => {
          this.$toast(res.resultMsg)
          return
        })

      },
      //调用微信支付界面
			onBridgeReady() {
				var _this = this;
				WeixinJSBridge.invoke(
					'getBrandWCPayRequest', this.wxdata,
					function(res) {
						_this.wxmsg = res;
						// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
						if(res.err_msg == "get_brand_wcpay_request:ok") {
							//修改为已支付但未到账
							if(_this.$route.query.state != 1) {
								_this.$router.replace({
									path: '/cell/orderpaysuccess',
									query: {
										"mchNo": _this.mchNo,
										"state": _this.state,
										'channel': _this.item.chunnelCode
									}
								})
							} else {
                              setTimeout(function(){
                              	_this.$router.replace({
									path: '/cell/orderdetail',
									query: {
										"shopAlias": _this.$route.query.shopAlias,
										"orderno": _this.$route.query.goodsOrderNo,
										"success":1
									}
								})
                              },1500)

							}
							//window.location.href = baseUrl + '/msweixin/hadPay?mchNo=' + mchNo;
						} else if(res.err_msg == "get_brand_wcpay_request:fail") {
							_this.$toast(res.err_code + ":" + res.err_desc + ":" + res.err_msg);
              //3:不允许跨号支付（gh_4bfb97195d7d--wx9f5e95f9a8da6dd9）:get_brand_wcpay_request:fail
							api.updateIncome(tempIncomeDetailId, "微信支付错误：get_brand_wcpay_request:fail，code=" + res.err_code);
							if(res.err_code == 3) {
								_this.$toast("不允许跨行支付");
								return;
							}
							_this.$router.push({
								path: '/cell/payfail'
							})

						} else if(res.err_msg == "get_brand_wcpay_request:cancel") {
              //取消支付
							api.updateIncome(tempIncomeDetailId, "微信支付取消：get_brand_wcpay_request:cancel，code=" + res.err_code);
							return;
							//取消
						} else if(res.err_msg == "get_brand_wcpay_request:fail_invalid appid") {
							_this.$toast("程序内部错误。");
							api.updateIncome(tempIncomeDetailId, "微信支付程序内部错误：get_brand_wcpay_request:fail_invalid appid，code=" + res.err_code);
							return;
						} else {
							api.updateIncome(tempIncomeDetailId, "微信支付未知错误：err_msg=" + res.err_msg + "，code=" + res.err_code);
							return;
						}
					}
				);
			},
			payinit() {
					this.getPayWay1();
			}
    },
		created() {
      this.$indicator.open();
      this.payinit();
      // this.getmerData = localStorage.getItem('mre_'+ this.$route.query.shopAlias+'_'+casherAlias);
      //存储收银员员信息
      this.merPush();
      //根据店铺别名 获取 收银员别名
      this.getmerData = localStorage.getItem('mre_'+ this.$route.query.shopAlias)
			//this.share(localStorage.shopname,localStorage.shopdesc,location.href,localStorage.shoplogo)

		},
		mounted() {
		},
	}
</script>

<style>
	.pricebox {
		text-align: center;
	}

	.pricetitle {
		font-size: 16px;
		color: #888;
	}

	.pricefee {
		font-size: 22px;
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/pay/cellorder.vue